import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPage.css';

function ContactPage() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="static-page">
      <nav className={`nav ${scrolled ? 'nav-scrolled' : ''}`}>
        <div className="nav-container">
          <a href="/" className="nav-logo" aria-label="CerebralMachines home"><img src="/CMLogo.png" alt="CerebralMachines" /></a>
          <div className="nav-links">
            <a href="/">Home</a>
            <a href="/platform">Platform</a>
            <a href="/how-it-works">How it Works</a>
            <a href="/use-cases">Use Cases</a>
            <a href="/consulting">Consulting</a>
          </div>
          <div className="nav-actions">
            <button className="btn-ghost" onClick={() => navigate('/login')}>Sign In</button>
            <button className="btn-primary" onClick={() => navigate('/request-demo')}>Request a Demo</button>
          </div>
        </div>
      </nav>

      <section className="sp-hero">
        <div className="sp-container">
          <h1 className="sp-hero-title">Contact Us</h1>
          <p className="sp-hero-text">
            Have a question, want to discuss a use case, or ready to get started? We'd love to hear from you.
          </p>
        </div>
      </section>

      <section className="sp-section">
        <div className="sp-container">
          <div className="sp-cards">
            <div className="sp-card">
              <h3>General Inquiries</h3>
              <p>
                For general questions about CerebralMachines, our platform, or partnership opportunities.
              </p>
              <p className="sp-emphasis">info@cerebralmachines.ai</p>
            </div>
            <div className="sp-card">
              <h3>Sales &amp; Demos</h3>
              <p>
                Interested in a demo or discussing how CerebralMachines can help your organization?
              </p>
              <p className="sp-emphasis">sales@cerebralmachines.ai</p>
            </div>
            <div className="sp-card">
              <h3>Careers</h3>
              <p>
                Want to join our team and help build the future of enterprise cognitive AI?
              </p>
              <p className="sp-emphasis">careers@cerebralmachines.ai</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sp-section sp-section-alt">
        <div className="sp-container" style={{ textAlign: 'center' }}>
          <h2 className="sp-section-title">Ready to Get Started?</h2>
          <p className="sp-hero-text">
            See CerebralMachines in action — schedule a personalized demo with our team.
          </p>
          <button className="btn-primary" onClick={() => navigate('/request-demo')}>
            Request a Demo
          </button>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-main">
            <div className="footer-brand">
              <a href="/" className="footer-logo" aria-label="CerebralMachines home"><img src="/CMLogo.png" alt="CerebralMachines" /></a>
              <p className="footer-tagline">Building the cognitive backbone for enterprise AI.</p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Product</h4>
                <ul>
                  <li><a href="/platform">Platform</a></li>
                  <li><a href="/how-it-works">How it Works</a></li>
                  <li><a href="/use-cases">Use Cases</a></li>
                  <li><a href="/consulting">Consulting</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About</a></li>
                  <li><a href="/team">Team</a></li>
                  <li><a href="/careers">Careers</a></li>
                  <li><a href="/contact">Contact</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Legal</h4>
                <ul>
                  <li><a href="/privacy">Privacy Policy</a></li>
                  <li><a href="/terms">Terms of Service</a></li>
                  <li><a href="/security">Security</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 CerebralMachines. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ContactPage;
